import { enumUnit, Unit } from '@rematter/frontend-lib-api-client';
import Big from 'big.js';
import minBy from 'lodash/minBy';

const poundsEquivalency: Record<Unit, number> = {
  [enumUnit.Pounds]: 1,
  [enumUnit.Ounces]: 1 / 16,
  [enumUnit.NetTons]: 2000,
  [enumUnit.ShortTons]: 2000,
  [enumUnit.GrossTons]: 2240,
  [enumUnit.LongTons]: 2240,
  [enumUnit.Kilograms]: 2.2046226218,
  [enumUnit.Grams]: 0.00220462,
  [enumUnit.MetricTons]: 2204.6226218,
  [enumUnit.ShortHundredweight]: 100,
  [enumUnit.LongHundredweight]: 112,
  [enumUnit.Each]: 0,
  [enumUnit.Yard]: 0,
  [enumUnit.Meter]: 0,
};

export const sumWeights = (weights: { value: number; unit: Unit }[]) => {
  const totalInPounds = weights
    .reduce(
      (acc, weight) =>
        acc.plus(new Big(weight.value).times(poundsEquivalency[weight.unit])),
      new Big(0),
    )
    .toNumber();

  const outputUnit =
    minBy(weights, ({ unit }) => poundsEquivalency[unit])?.unit ??
    enumUnit.Pounds;

  return {
    value: totalInPounds / poundsEquivalency[outputUnit],
    unit: outputUnit,
  };
};
